import { Injectable } from '@angular/core';

@Injectable()
export class APIService { 
    constructor() {
        
    }
}